import React from 'react'

import { AlignItems, Box, Display, Heading4, Join, Space } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { Equipment } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { menuPreferencesVisibilityChange } from 'actions/menu'
import { EquipmentBanner } from 'routes/Menu/components/Detail/Equipment/EquipmentBanner'
import { SectionPanel } from 'routes/Menu/components/Detail/SectionPanel'
import { RecipeAttributePill } from 'routes/Menu/components/RecipeAttributePill/RecipeAttributePill'
import { useAuth } from 'routes/Menu/domains/auth'

type RecipeEquipmentProps = {
  equipment?: Equipment[]
  loading: boolean
  onClose: () => void
}

export const RecipeEquipment = ({ equipment, loading, onClose }: RecipeEquipmentProps) => {
  const dispatch = useDispatch()
  const openMenuPreferences = () => {
    onClose()
    dispatch(menuPreferencesVisibilityChange(true))
  }

  const { isAuthenticated } = useAuth()
  if (!equipment || equipment.length < 1 || loading) {
    return null
  }

  return (
    <SectionPanel>
      <Join with={<Space size={3} />}>
        <Heading4>Equipment Needed</Heading4>
        <Box alignItems={AlignItems.FlexStart} wrap display={Display.Flex}>
          {equipment.map((item) => (
            <RecipeAttributePill key={item.name} text={item.name} />
          ))}
        </Box>
        {isAuthenticated && <EquipmentBanner equipment={equipment} onClick={openMenuPreferences} />}
      </Join>
    </SectionPanel>
  )
}
